import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Nav } from 'react-bootstrap';

const JavaScritpTester = () => {
  const testing = false;
  const test = () => {
    /*
    y.toastInfo('KKKKKKKKKK');
    y.modal.dialog(
      '提醒',
      '',
      '编号为 123123,1234123 的单号已经开票，继续吗？',
      [
        {
          text: '__Continue',
          click: () => {
            console.log('kkkkkkkk', 'Continue');
          },
          variant: 'warning'
        },
        {
          text: '__Cancel',
          click: () => {
            console.log('kkkkkkkk', 'Cancel');
          },
          variant: 'outline-secondary'
        }
      ]
    );
    */
  };

  return testing ? (
    <Nav.Item as={'li'}>
      <Nav.Link className="px-2 theme-control-toggle" onClick={() => test()}>
        <FontAwesomeIcon
          color="rgb(44, 123, 229)"
          icon={['fas', 'puzzle-piece']}
          className="fs-0"
        />
      </Nav.Link>
    </Nav.Item>
  ) : null;
};

export default JavaScritpTester;
